
import catchify from 'catchify';
import get from 'lodash/get';
import frag from 'vue-frag';
import {
  GETBEAMER_SEGMENT_TYPE,
  GETBEAMER_USER_TYPE,
} from '@/constants/global';
import NavBarPromoButton from './NavBarPromoButton.vue';

export default {
  components: {
    NavBarPromoButton,
  },
  directives: { frag },
  props: {
    group: {
      type: String,
      default: '',
    },
  },
  async fetch() {
    await this.fetchSuggestions();
    if (this.$config.getBeamerProductId) {
      await this.initGetBeamerNotification();
    }
  },
  data() {
    return {
      options: [],
      showBeamerNotification: false,
      isMobileOpen: false,
    };
  },
  computed: {
    getBeamerConfig() {
      if (!this.showBeamerNotification) {
        return {};
      }

      const config = {
        product_id: this.$config.getBeamerProductId,
        selector: '#beamerButton',
        top: -10,
        right: -9,
        user_type: GETBEAMER_SEGMENT_TYPE.ANONYMOUS, // an: for getBeamer segments report
        filter: GETBEAMER_SEGMENT_TYPE.ANONYMOUS, // an: for getBeamer post detail report
      };

      const { user } = this.$store.state.session;

      if (user) {
        const userSegmentType = user.has_plus
          ? GETBEAMER_SEGMENT_TYPE.PLUS
          : GETBEAMER_SEGMENT_TYPE.NON_PLUS;

        config.user_email = user.email;
        config.user_firstname = user.first_name;
        config.user_lastname = user.last_name;
        config.user_type = userSegmentType;
        config.filter = userSegmentType;
      }

      return config;
    },
    groups() {
      const group = this.$store.state.browse.attributes.find((a) => a.slug === 'group');

      return group?.type_options?.options || [];
    },
    showPartnerPortal() {
      return get(this, ['$store', 'state', 'session', 'user', 'has_partner_portal']);
    },
    wishlistExperiment() {
      return this.$store.getters['wishlists/wishlistExperiment'];
    },
    showWishlistsLink() {
      return this.wishlistExperiment === 'enabled';
    },
  },
  watch: {
    $route() {
      this.closeMobile();
    },
    // TODO:: Need to clean this up in the future.
    '$store.state.autocompleteQuery': function () { // eslint-disable-line func-names
      this.fetchSuggestions();
    },
    '$store.state.autocompleteProductType': function () { // eslint-disable-line func-names
      this.fetchSuggestions();
    },
    '$store.state.autocompleteGroup': function () { // eslint-disable-line func-names
      this.fetchSuggestions();
    },
  },
  methods: {
    closeMobile() {
      this.isMobileOpen = false;
    },
    toggleMobile() {
      this.isMobileOpen = document.querySelector('body').classList.toggle('overflow-hidden');
    },
    async initGetBeamerNotification() {
      const getBeamerUserType = this.$config.getBeamerUserType.toLowerCase().split(',');

      if (getBeamerUserType.includes(GETBEAMER_USER_TYPE.ALL)) {
        this.showBeamerNotification = true;
        return;
      }

      const { user } = this.$store.state.session;

      // an: enable for not logged in users if query is present
      if (!user && this.$route.query?.notify_anonymous === 'true') {
        this.showBeamerNotification = true;
        return;
      }

      if (user) {
        if (getBeamerUserType.includes(GETBEAMER_USER_TYPE.ALL_USERS)) {
          this.showBeamerNotification = true;
        } else if (getBeamerUserType.includes(GETBEAMER_USER_TYPE.BETA) && user.is_betaling) {
          this.showBeamerNotification = true;
        } else if (getBeamerUserType.includes(GETBEAMER_USER_TYPE.PLUS) && user.has_plus) {
          // an: For now the experiment is only for PLUS users
          const experiment = await this.$experiments.enroll('enable-get-beamer');
          this.showBeamerNotification = experiment && experiment.toString() === 'true';
        }
      }
    },
    async fetchSuggestions() {
      const query = this.$store.state.autocompleteQuery;
      const productType = this.$store.state.autocompleteProductType;
      const group = this.$store.state.autocompleteGroup;

      let apiUrl = '/api/v2/deals/esbrowse/?status=current&sort=recommended&toptrending=1&per_page=5';

      if (query && query.length) {
        const { categories } = this.$store.state.browse;
        const lowerQuery = query.toLowerCase();
        const category = categories.find(
          (c) => c.display.toLowerCase().localeCompare(lowerQuery) === 0,
        );

        if (category) {
          apiUrl = `/api/v2/deals/esbrowse/?status=all&sort=recommended&product_tags[all]=${category.value}&per_page=5&autocomplete=1`;
        } else {
          apiUrl = `/api/v2/deals/esbrowse/?status=all&sort=recommended&query=${query}&per_page=5&autocomplete=1`;
        }
      }

      if (productType) {
        apiUrl += `&attribute[product_type]=${productType}`;
      }

      if (group) {
        apiUrl += `&attribute[group]=${group}`;
      }

      const [error, response] = await catchify(
        this.$cachios.get(apiUrl),
      );

      if (error || !(response && response.data && response.data.deals)) return;

      this.options = response.data.deals || [];
    },
  },
  head() {
    return {
      script: [
        {
          skip: !this.showBeamerNotification,
          hid: 'getbeamer-productid',
          innerHTML: `var beamer_config = ${JSON.stringify(this.getBeamerConfig)};`,
          body: true,
        },
        {
          skip: !this.showBeamerNotification,
          hid: 'getbeamer-script',
          src: 'https://app.getbeamer.com/js/beamer-embed.js',
          defer: true,
          body: true,
        },
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'getbeamer-productid': ['innerHTML'],
      },
    };
  },
};
